/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-06-14 17:38:42
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-06-23 17:17:48
 * @FilePath: \front_admin\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vuex from 'vuex'
import {
  taxPlate
} from './taxPlate'
import {
  info
} from './info'
import {
  valueAdd
} from './valueAdd'
import {
  menu
} from "./menu";
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    companyShow: true,
    company: '',
    url: "",
    clientCompany: '', //客户公司账簿
    pkCorp: '',
    buyServiceData: {
      limitedSpace: [],
      discount: []
    }, //购买的平台服务data
    isOpenNavTip: false, //是否打开业务导航
    skuArr: [], // 增值服务购买生成的sku 填写的折扣
  },
  modules: {
    taxPlate,
    info,
    valueAdd,
    menu,
  },
  mutations: {
    setCompanyShow(state, data) {
      state.companyShow = data
    },
    setCompany(state, data) {
      state.company = data
    },
    setUrl(state, data) {
      state.url = data
    },
    setClientCompany(state, data) {
      state.clientCompany = data
    },
    setPkCorp(state, data) {
      state.pkCorp = data
    },
    setBuyServiceData(state, data) {
      state.buyServiceData = data
    },
    setIsOpenNavTip(state, data) {
      state.isOpenNavTip = data
    },
    setSkuArr(state, data) {
      state.skuArr = data
    },
  }
})
export default store
